export function normalizeWorkspacePresence(value) {
    const memberships = Array.isArray(value) ? value : [];
    const seen = new Set();
    return memberships.filter((membership) => {
        const key = membership?.documentId || membership?.id;
        if (!key || !membership?.userId || seen.has(String(key))) return false;
        seen.add(String(key));
        return true;
    }).map((membership) => ({
        id: membership.id,
        documentId: membership.documentId || null,
        userId: membership.userId,
    }));
}

export function memberIsOnline(memberData, workspacePresence) {
    const membership = memberData?.member ? memberData : null;
    const member = membership?.member || memberData;
    const userKeys = [member?.id, member?.documentId].filter(Boolean).map(String);
    const membershipKeys = membership
        ? [membership.id, membership.documentId].filter(Boolean).map(String)
        : [];
    return (Array.isArray(workspacePresence) ? workspacePresence : []).some((presence) => (
        userKeys.includes(String(presence?.userId))
        || membershipKeys.includes(String(presence?.documentId || presence?.id))
    ));
}
